require('./_global.js');

function printCitation(){
  const citation = getCitation();
  let newWin= window.open("",'_blank');
  let citationText = $('#citation').html();
  citationText += `${citation.primarySourceInfo}\n\r${citation.primarySourceUrl}`;
  newWin.document.write(citationText);
  newWin.document.close();
  newWin.print();
  newWin.close();
}

function retrieveCitation(){
  const citation = getCitation();
  return `Title: ${citation.title}\n\rCreator: ${citation.creator}\n\rPublication Date: ${citation.publicationDate}\n\rPrimary Source: ${citation.primarySourceInfo}\n\rSource URL: ${citation.primarySourceUrl}`;
}

function getCitation() {
  return {
    title: $('#citation-title').text(),
    creator: $('#citation-creator').text(),
    publicationDate: $('#citation-publication-date').text(),
    primarySourceInfo: $('#citation-primary-source-info').text(),
    primarySourceUrl: $('#citation-primary-source-url').text()
  };
}

export {printCitation, retrieveCitation};
